var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "",
        visible: _vm.examVisible,
        width: "30%",
        center: "",
        "show-close": false,
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.examVisible = $event
        }
      }
    },
    [
      _c("span", [_vm._v("测试须知：" + _vm._s(_vm.exam.examDescription))]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("span", [
          _vm._v("测试机会：" + _vm._s(_vm.exam.remainingExamTimes) + "次")
        ]),
        _vm._v(" "),
        _c("span", [_vm._v("时间：" + _vm._s(_vm.exam.examDuration) + "分钟")]),
        _vm._v(" "),
        _c("span", [_vm._v("题目：" + _vm._s(_vm.exam.questionNum) + "题")])
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.returnCourseList } }, [
            _vm._v("重新学习")
          ]),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.beginExam } },
            [_vm._v("开始测试")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d24141b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d24141b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/examDialog.vue
// module id = 1547
// module chunks = 0